import React from 'react';
import { Table } from 'react-bootstrap';
import PropTypes from 'prop-types';

import Head from './Head';
import Body from './Body';

const PaymentsTable = ({ items, config, sort, filters, isLoading, fetchTableFilters, onSortTable, onSelectAction, onSelectMethods }) => (
  <>
    <Table className="payments__table">
      <Head
        config={config}
        sort={sort}
        filters={filters}
        fetchTableFilters={fetchTableFilters}
        onSortTable={onSortTable}
        onSelectMethods={onSelectMethods}
      />
      {!isLoading ? <Body items={items} config={config} onSelectAction={onSelectAction} /> : null}
    </Table>
    {isLoading && (
      <div className="loader-container">
        <div className="modal-loader modal-loader-with-text" />
      </div>
    )}
  </>
);

PaymentsTable.propTypes = {
  items: PropTypes.array,
  config: PropTypes.object,
  sort: PropTypes.object,
  filters: PropTypes.object,
  isLoading: PropTypes.bool,
  fetchTableFilters: PropTypes.func,
  onSortTable: PropTypes.func,
  onSelectAction: PropTypes.func,
  onSelectMethods: PropTypes.func,
};

export default PaymentsTable;
